var _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.0312,
    y1: 19.0098,
    x2: 6.0104,
    y2: 6.98899,
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00977 19.0098L18.0306 6.98895",
    className: "stroke",
    stroke: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8aa7359c1d5099dcc218f27071f9079a.svg";
export { ForwardRef as ReactComponent };